import React, { useContext, useState } from "react";
import { searchVehicle } from "../../../../../api/vehicleApiClient";
import { PlateNumberInput } from "../../../../../components/inputs/PlateNumberInput";
import { ProcessingContext } from "../../../../../contexts/ProcessingContext";
import { QuotationContext } from "../../../../../contexts/QuotationContext";
import { Vehicle } from "../../../../../model/vehicle";
import { strings } from "../../../../../strings/strings";
import { fetchMethod } from "../../../../../utils/utils";
import { VehicleSearchNotFoundDialog } from "./Dialogs/VehicleSearchNotFoundDialog";
import { VehicleSearchSelectDialog } from "./Dialogs/VehicleSearchSelectDialog";
import "./MtplVehicleSearchViewStyles.scss";

interface VehicleSearchViewProps {
    onSearchListener: (vehicle: Vehicle) => void;
    toManualInputListener: () => void;
    description: () => React.ReactElement;
    plateNumberDescription?: string;
}

export const VehicleSearchView = ({
    onSearchListener,
    toManualInputListener,
    description,
    plateNumberDescription,
}: VehicleSearchViewProps) => {
    const [vehicles, setVehicles] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const { setProcessingOpen } = useContext(ProcessingContext);
    const { quotation, defaultPlateNumber, saveTempValues, type } = useContext(QuotationContext);
    const [plateNumber, setPlateNumber] = useState(
        localStorage.getItem(`${type}_plateNumber`) || defaultPlateNumber,
    );

    function handleFoundVehicles(value: Vehicle[], plateNumber: string) {
        if (value.length === 1) {
            onSearchListener(value[0]);
        } else if (value.length === 0) {
            setVehicles([]);
            setPlateNumber(plateNumber);
            setShowDialog(true);
        } else {
            setVehicles(value);
            setPlateNumber(plateNumber);
            setShowDialog(true);
        }

        if (value.length > 0) {
            const event = () => {
                switch (quotation.salesVariant) {
                    case "svs_05910264_package":
                        return "_SD_go_by_auto";
                    case "svs_05910203_simple":
                        return "mtpl_go_by_auto";
                    case "svs_09710001_simple":
                        return "green_card_go_auto";
                }
            };
            console.log("Google Analytics Event = " + event());
            // @ts-ignore
            window.dataLayer.push({ event: event() });
        } else if (quotation.salesVariant === "svs_09710001_simple") {
            const event = "green_card_go_error";
            console.log("Google Analytics Event = " + event);
            // @ts-ignore
            window.dataLayer.push({ event: event });
        }
    }

    const onPlateNumberComplete = async (plateNumber: string) => {
        setProcessingOpen(true);
        await fetchMethod(
            () => searchVehicle(plateNumber),
            (response) => {
                handleFoundVehicles(response.data, plateNumber);
            },
            () => {
                handleFoundVehicles([], plateNumber);
            },
            () => {
                setProcessingOpen(false);
            },
        );
    };

    return (
        <div className={"step-view vehicle-search-view"}>
            <div className={"vehicle-search-view__search"}>
                <div className={"vehicle-search-view__search__title"}>
                    <span>{strings.vehiclePlateNumberType}</span>
                </div>
                <div className={"vehicle-search-view__search__input"}>
                    <PlateNumberInput
                        name={"plateNumber"}
                        value={plateNumber}
                        onChange={(value) => {
                            saveTempValues("plateNumber", value);
                            setPlateNumber(value);
                        }}
                        onSearchListener={(value) => {
                            onPlateNumberComplete(value);
                        }}
                    />
                </div>
                <div className={"vehicle-search-view__search__help"}>
                    <span>{plateNumberDescription || strings.vehiclePlateNumberDescription}</span>
                </div>
            </div>
            <div className={"vehicle-search-view__description"}>{description()}</div>

            <VehicleSearchNotFoundDialog
                open={vehicles.length === 0 && showDialog}
                notFoundPlateNumber={plateNumber}
                toManualInputListener={toManualInputListener}
                onClose={() => {
                    setVehicles([]);
                    setShowDialog(false);
                }}
            />

            <VehicleSearchSelectDialog
                open={vehicles.length > 1 && showDialog}
                vehicles={vehicles}
                toManualInputListener={toManualInputListener}
                onSelect={(vehicle) => {
                    onSearchListener(vehicle);
                }}
                onClose={() => {
                    setVehicles([]);
                    setShowDialog(false);
                }}
            />
        </div>
    );
};
